import { Options } from '@splidejs/react-splide';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { productName } = ApplicationDomainUtility;

export const testimonialDatas = [
  {
    name: 'Rakesh Sharma',
    designation: `${productName} Trader`,
    testimonial: `I just set my entry rules and indicators. ${productName} takes care of everything else and executes my trades instantly without me doing anything manually.`,
    earnings: 'Really works',
  },
  {
    name: 'Gurpreet Singh',
    designation: `${productName} Trader`,
    testimonial: `Backtesting and paper trading on ${productName} helped me test my strategy before going live. Now it runs automatically and saves me so much time.`,
    earnings: 'Totally smooth',
  },
  {
    name: 'Ashok Kumar',
    designation: `${productName} Trader`,
    testimonial: `Trading feels easier now. I create my setup with indicators and rules, and ${productName} executes live trades in milliseconds without constant monitoring.`,
    earnings: 'No more stress',
  },
  {
    name: 'Sagar',
    designation: `${productName} Trader`,
    testimonial: `I’ve used many algo platforms, but ${productName}’s friendly interface and execution quality are the best I’ve seen..`,
    earnings: 'Loving this!',
  },
];

export const brokerLogoCarouselConfig = (isMobile: boolean): Options => {
  if (isMobile) {
    return {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '45px',
      autoplay: true,
      interval: 3000,
      speed: 500,
      pauseOnHover: true,
      arrows: false,
      pagination: true,
      rewind: true,
      autoWidth: true,
      focus: 'center',
      trimSpace: false,
    };
  }
  return {
    type: 'loop',
    autoScroll: {
      pauseOnHover: true,
      pauseOnFocus: false,
      rewind: true,
      speed: 1,
    },
    arrows: false,
    pagination: false,
    // fixedWidth: 500,
    autoWidth: true,
    gap: '40px',
    speed: 1000,
    wheel: false,
  };
};
